import { render, staticRenderFns } from "./ViewDetailComprehension.vue?vue&type=template&id=ebeeb02c&scoped=true&"
import script from "./ViewDetailComprehension.vue?vue&type=script&lang=js&"
export * from "./ViewDetailComprehension.vue?vue&type=script&lang=js&"
import style0 from "./ViewDetailComprehension.vue?vue&type=style&index=0&id=ebeeb02c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebeeb02c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VImg,VSimpleTable})
